exports.components = {
  "component---src-pages-hello-world-tsx": () => import("./../../../src/pages/hello-world.tsx" /* webpackChunkName: "component---src-pages-hello-world-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */)
}

